var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    rx: 4,
    fill: "url(#paint0_linear_3854_1294)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9184 43.2086L45.8438 39V84L96.9184 79.7914C98.2624 79.7914 98.9345 78.8201 98.9345 77.5252V45.7986C99.2705 44.1799 98.2624 43.2086 96.9184 43.2086ZM56.9323 72.6691C56.9323 73.964 55.9243 74.9353 54.5802 74.9353C53.2361 74.9353 52.2281 73.964 52.2281 72.6691V50.0072C52.2281 48.7122 53.2361 47.741 54.5802 47.741C55.9243 47.741 56.9323 48.7122 56.9323 50.0072V72.6691ZM69.365 71.0504C69.365 72.3453 68.3569 73.3165 67.0128 73.3165C65.6688 73.3165 64.6607 72.3453 64.6607 71.0504V51.3022C64.6607 50.0072 65.6688 49.036 67.0128 49.036C68.3569 49.036 69.365 50.0072 69.365 51.3022V71.0504ZM81.7976 69.4317C81.7976 70.7266 80.7895 71.6978 79.4455 71.6978C78.1014 71.6978 77.0934 70.7266 77.0934 69.4317V52.9209C77.0934 51.6259 78.1014 50.6547 79.4455 50.6547C80.7895 50.6547 81.7976 51.6259 81.7976 52.9209V69.4317ZM92.8862 68.7842C92.8862 70.0791 91.8781 71.0504 90.534 71.0504C89.19 71.0504 88.1819 70.0791 88.1819 68.7842V54.5396C88.1819 53.2446 89.19 52.2734 90.534 52.2734C91.8781 52.2734 92.8862 53.2446 92.8862 54.5396V68.7842Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1369 39L25.6801 43.2086C24.672 43.5324 24 44.5036 24 45.4748V77.2015C24 78.1727 24.672 79.1439 25.6801 79.4677L41.1369 83.6763V39Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3854_1294",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135FC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentIcon);
export default __webpack_public_path__ + "static/media/parentIcon.47211a589217fa58f6d34f4f84744751.svg";
export { ForwardRef as ReactComponent };